import Shuffle from "./_shuffle.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        const shuffle = new Shuffle();

        this.skipHeaderAnime();
        this.hideShadow();
    }

    skipHeaderAnime() {
        const url = document.referrer;
        const results = url.match(/character/);

        if (results) {
            document.body.classList.add("-noanime");
        } else {
            return;
        }
    }

    hideShadow() {
        const charactercont = document.querySelector(".character__cont");
        const mainph = document.querySelector(".character__main__ph");

        mainph.addEventListener("animationend", () => {
            charactercont.classList.add("-phin");
        });
    }
}
